import { render, staticRenderFns } from "./main.vue?vue&type=template&id=30bec0fc&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bec0fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bec0fc')) {
      api.createRecord('30bec0fc', component.options)
    } else {
      api.reload('30bec0fc', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=30bec0fc&scoped=true", function () {
      api.rerender('30bec0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/view/components/modal-copy/main.vue"
export default component.exports